import { c as _c } from "react/compiler-runtime";
import { useMemo } from 'react';
import { useQuery } from '@apollo/client';
import { GET_PRODUCTS_STATIC_DATA } from '@/graphql/queries';
import getVisitorLocationQueryVariables from 'commons/getVisitorLocationQueryVariables';
import removeTypename from 'commons/removeTypename';
import useUserLocation from 'global-state/userLocation/useUserLocation';
import useProductVariantsToShow from 'hooks/useProductListingData/useProductVariantsToShow';
import useProductListingWithFavorites from 'hooks/useProductListingData/useProductListingWithFavorites';
import addDerivedProductData from 'hooks/useProductListingData/helpers/addDerivedProductData';
const useProductCardDataNext = t0 => {
  const $ = _c(23);
  const {
    productIds: t1
  } = t0;
  let t2;
  if ($[0] !== t1) {
    t2 = t1 === undefined ? [] : t1;
    $[0] = t1;
    $[1] = t2;
  } else {
    t2 = $[1];
  }
  const productIds = t2;
  const userLocation = useUserLocation();
  const zipCode = userLocation?.zip ?? "";
  const t3 = userLocation?.stateShortName;
  let t4;
  if ($[2] !== t3) {
    t4 = getVisitorLocationQueryVariables(t3);
    $[2] = t3;
    $[3] = t4;
  } else {
    t4 = $[3];
  }
  let t5;
  if ($[4] !== productIds || $[5] !== t4 || $[6] !== zipCode) {
    t5 = {
      productIds,
      zipCode,
      ...t4,
      limit: -1
    };
    $[4] = productIds;
    $[5] = t4;
    $[6] = zipCode;
    $[7] = t5;
  } else {
    t5 = $[7];
  }
  const t6 = productIds.length === 0;
  let t7;
  if ($[8] !== t5 || $[9] !== t6) {
    t7 = {
      fetchPolicy: "cache-and-network",
      variables: t5,
      skip: t6
    };
    $[8] = t5;
    $[9] = t6;
    $[10] = t7;
  } else {
    t7 = $[10];
  }
  const {
    data,
    loading
  } = useQuery(GET_PRODUCTS_STATIC_DATA, t7);
  const queryData = data?.getProductsStaticData;
  let t8;
  if ($[11] !== queryData) {
    t8 = queryData ? removeTypename(queryData) : {};
    $[11] = queryData;
    $[12] = t8;
  } else {
    t8 = $[12];
  }
  const pageData = t8;
  const {
    products: productsWithoutDerivedData,
    upholsteryOptions
  } = pageData;
  let t9;
  if ($[13] !== productsWithoutDerivedData || $[14] !== upholsteryOptions) {
    t9 = productsWithoutDerivedData?.map(product => addDerivedProductData({
      product,
      upholsteryOptions
    })) || [];
    $[13] = productsWithoutDerivedData;
    $[14] = upholsteryOptions;
    $[15] = t9;
  } else {
    t9 = $[15];
  }
  const products = t9;
  let t10;
  if ($[16] !== products) {
    t10 = {
      colorFilters: null,
      products,
      upholsteryLabelFilters: null
    };
    $[16] = products;
    $[17] = t10;
  } else {
    t10 = $[17];
  }
  const productsWithVariantsToShow = useProductVariantsToShow(t10);
  let t11;
  if ($[18] !== productsWithVariantsToShow) {
    t11 = {
      products: productsWithVariantsToShow
    };
    $[18] = productsWithVariantsToShow;
    $[19] = t11;
  } else {
    t11 = $[19];
  }
  const productsToShowWithFavorites = useProductListingWithFavorites(t11);
  let t12;
  if ($[20] !== loading || $[21] !== productsToShowWithFavorites) {
    t12 = {
      loading,
      products: productsToShowWithFavorites
    };
    $[20] = loading;
    $[21] = productsToShowWithFavorites;
    $[22] = t12;
  } else {
    t12 = $[22];
  }
  return t12;
};
export default useProductCardDataNext;